import { useState } from 'react';
import { Item } from '../../mechanics/items/Item';
import ToolTip, { IToolTipObject } from '../ui/ToolTip';
import { useAppDispatch, useAppSelector } from "../../store/store";
import { uiSlice } from '../../store/reducers/uiReducer';
import ImgWithFallback from '../ui/ImgWithFallback';

interface IShopItemProps {
    item: Item
    itemClick: () => void
}

const ShopItem = ({ item, itemClick }: IShopItemProps) => {
    const dispatch = useAppDispatch()
    const { setToolTipContent } = uiSlice.actions
    const toolTipContent = useAppSelector(state => state.uiReducer.toolTipContent)

    const [isToolTipView, setIsToolTipView] = useState(false)

    function callToolTip(tipContent: string) {
        setIsToolTipView(true)
        dispatch(setToolTipContent(tipContent))
    }

    const toolTipObjectContent: IToolTipObject = {
        type: item.getType(),
        name: item.getName(),
        restoreValue: item.getRestoreValue(),
        cost: item.getCost()
    }

    return (
        <li
            className="shop__body-item"
            onClick={itemClick}
            onMouseEnter={() => callToolTip(toolTipContent)}
            onMouseLeave={() => setIsToolTipView(false)}
        >
            {item.getImg().img && <ImgWithFallback src={item.getImg().webp} fallbackSrc={item.getImg().img} />}
            <span>{item.getCount()}</span>
            {isToolTipView ? <ToolTip text='' position='top-inventory-items' toolTipObjectContent={toolTipObjectContent} /> : null}
        </li>
    );
};

export default ShopItem;